import { Body1, makeStyles } from "@fluentui/react-components";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { IPanelEditarCatalogo } from "../editarCatalogo/PanelEditarCatalogo";
import { UsePanelOcultoCatalogo } from "./UsePanelOcultoCatalogo";
import { Warning24Filled } from "@fluentui/react-icons";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { useCallback } from "react";

const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      top: "100%",
      alignItems: "center",
    },
  
    warning: {
      color: " #eaa300",
      width: "60px",
      height: "60px",
    },
  });
export const PanelOcultoCatalogo=(props:IPanelEditarCatalogo)=>{
    const styles = useStyles();
    const {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status} = UsePanelOcultoCatalogo(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto={props.item.esOculto?"Habilitar":"Ocultar"}
              texto2={"Salir"}
              onClick={putEditarCatalogo}
              onDismiss={() => {
                reset()
              }}
            />
          </>
        ),
        [request]
      );
    return (
        <PanelDrawer
        isOpen={props.isOpen}
        onDismiss={reset}
        textHeader={props.item.esOculto ? "Habilitar Catalogo" : "Ocultar Catalogo"}
        mensaje={mensaje}
        loading={loading}
        onRenderFooter={onRenderFooter} status={status} >
         <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          ¿Desea
                          {props.item.esOculto?" habilitar":" ocultar"} el Catalogo: {props.item.nombreCatalogoInseguro}?
                        </Body1>
                      </div>
                    </div>
                  </>
       </PanelDrawer>
    )
}